"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Check = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Check"));

// Generated by script, don't edit it please.
var Check = (0, _createSvgIcon["default"])({
  as: _Check["default"],
  ariaLabel: 'check',
  category: 'application',
  displayName: 'Check'
});
var _default = Check;
exports["default"] = _default;
module.exports = exports.default;